import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, makeStyles } from "@material-ui/core";

import React from "react";
import { TheCycleverseTheme } from "src/theme";

const useTableStyles = makeStyles((theme: TheCycleverseTheme) => ({
  container: {
    // marginRight: '40px',
    borderRadius: 0,
    maxWidth: "45%",
    boxShadow: "none",
    [theme.breakpoints.down("sm")]: {
      // marginBottom: '40px',
      marginRight: "0px",
      borderRadius: 0,
      maxWidth: "100%",
      boxShadow: "none",
    },
  },
  tableCell: {
    border: `0.5px solid #CED4D9`,
    fontFamily: "Roboto",
    fontWeight: 300,
    fontSize: "16px",
    lineHeight: "23px",
    textAlign: "center",
    width: "50%",
  },
  headerRow: {
    background: theme.highlightGradientBg,
  },
  headerCell: {
    fontFamily: "Roboto",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "23px",
    color: "white",
  },
  secondCell: {
    textAlign: "center",
  },
}));

export const CalculatorPSIBARTable = ({ title1, title2, data }) => {
  const classes = useTableStyles();
  return (
    <TableContainer component={Paper} className={classes.container}>
      <Table size="small" aria-label="customized table">
        <TableHead>
          <TableRow className={`${classes.headerRow}`}>
            <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>{title1}</TableCell>
            <TableCell className={`${classes.tableCell} ${classes.headerCell} ${classes.secondCell}`} align="right">
              {title2}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow key={row.key}>
              <TableCell className={classes.tableCell} component="th" scope="row">
                {row.key}
              </TableCell>
              <TableCell className={`${classes.tableCell} ${classes.secondCell}`} align="right">
                {row.value}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
